import React from "react";

const ManageOrdersvg = ({
  fill = "#B0B3C7",
  width = "14px",
  height = "14px",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0833 0H2.91668C1.30583 0 0 1.30583 0 2.91665C0 3.88314 0.783508 4.66665 1.75 4.66665H12.25C13.1713 4.67789 13.9402 3.96613 14 3.04672C14.0702 1.43582 12.8213 0.0729805 11.2104 0.00276172C11.168 0.000902344 11.1257 0 11.0833 0Z"
        fill={fill}
      />
      <path
        d="M12.8335 5.8335H1.16682C0.844656 5.8335 0.583496 6.09466 0.583496 6.41682V11.0835C0.58541 12.6935 1.89012 13.9982 3.50014 14.0002H10.5001C12.1102 13.9982 13.4149 12.6935 13.4168 11.0835V6.41682C13.4168 6.09466 13.1556 5.8335 12.8335 5.8335ZM8.75015 8.75017H5.25014C4.92798 8.75017 4.66682 8.48901 4.66682 8.16685C4.66682 7.84468 4.92798 7.58352 5.25014 7.58352H8.75015C9.07231 7.58352 9.33347 7.84468 9.33347 8.16685C9.33347 8.48901 9.07231 8.75017 8.75015 8.75017Z"
        fill={fill}
      />
    </svg>
  );
};

export default ManageOrdersvg;
